import { useState } from 'react';
import { LOAN_PHASES, LoanPhases } from '../LoanPhase.constanst';
import { useGetLoanDocByLoan } from 'services/loan/querys';

// Utils
import { processLenderTaskItems } from './utils/processorLenderTaskItem';
import { processBorrowerTaskItems } from './utils/processorBorrowerTaskItem';
import { determinePhaseState } from './utils/processorPhaseStates';

interface UseLoanPhasesProps {
  loan: any;
  tasks: any[];
  handlerSetProgressData: any;
}

export const useLoanPhases = ({
  loan,
  tasks,
  handlerSetProgressData
}: UseLoanPhasesProps) => {
  const [phaseSelect, setPhaseSelect] = useState<LoanPhases>();

  const { data: loanDocs, reexecute: getLoanDocs } = useGetLoanDocByLoan({ 
    variables: { loanId: loan._id } 
  });

  const getLoanPhases = () => {
    if (!tasks || !loanDocs) return [];

    const phases: any = JSON.parse(JSON.stringify(LOAN_PHASES));


    phases.forEach((phase: any) => {
      const filteredRulesTaskCards = processBorrowerTaskItems(
        phase,
        loanDocs, 
        loan,
        tasks
      );

      processLenderTaskItems(
        phase, 
        loanDocs || [], 
        tasks, 
        loan
      );

      const { state, stateName } = determinePhaseState(
        filteredRulesTaskCards || [], 
        loanDocs || [], 
        phase
      );
      phase.state = state;
      phase.stateName = stateName;
    });

    return phases;
  };

  const phases = getLoanPhases();

  return {
    phases,
    phaseSelect,
    setPhaseSelect,
    loanDocs
  };
};